import ContextSwitcher from './ContextSwitcher';
import ConnectGmail from '../../features/google/ConnectGmail';

/* Only the Gmail connection sits on the right — who's signed in is already in
   the sidebar, which is also where Profile and Log out live. */
export default function Topbar() {
  return (
    <div className="topbar">
      <ContextSwitcher />
      <div className="topbar-right">
        {/* the Gmail account every "send" in the portal goes out from — here,
            not on one page, so any page can send */}
        <ConnectGmail />
      </div>
    </div>
  );
}
